export enum UmpireOttAvailability {
  FREE = 'free',
  PPV = 'pay_per_view',
  SUBSCRIPTION = 'subscription',
}
